import React from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
  className?: string;
  variant?: 'default' | 'white' | 'gray';
}

const Logo: React.FC<LogoProps> = ({ className = "", variant = 'default' }) => {
  const getTextColor = () => {
    switch (variant) {
      case 'white':
        return 'text-white';
      case 'gray':
        return 'text-atren-gray';
      default:
        return 'text-atren-gray';
    }
  };

  const getOrangeColor = () => {
    switch (variant) {
      case 'white':
        return 'text-white';
      case 'gray':
        return 'text-atren-orange';
      default:
        return 'text-atren-orange';
    }
  };

  return (
    <Link to="/" className={`flex items-center space-x-4 cursor-pointer ${className}`}>
      {/* Architectural Icon */}
      <div className="relative transform scale-125">
        <div className="flex items-end space-x-1">
          {/* Building 1 */}
          <div className={`w-5 h-10 ${variant === 'white' ? 'bg-white' : 'bg-atren-gray'} rounded-sm relative shadow-lg`}>
            <div className={`absolute top-1 left-1 w-1.5 h-1.5 ${variant === 'white' ? 'bg-atren-gray' : 'bg-white'} rounded-xs`}></div>
            <div className={`absolute top-3.5 left-1 w-1.5 h-2.5 ${variant === 'white' ? 'bg-atren-gray' : 'bg-white'} rounded-xs`}></div>
          </div>
          {/* Building 2 */}
          <div className={`w-4 h-8 ${getOrangeColor() === 'text-white' ? 'bg-atren-orange' : 'bg-atren-orange'} rounded-sm relative shadow-lg`}>
            <div className={`absolute top-1.5 left-1 w-1 h-1 ${variant === 'white' ? 'bg-white' : 'bg-white'} rounded-xs`}></div>
          </div>
          {/* Building 3 */}
          <div className={`w-3 h-6 ${variant === 'white' ? 'bg-white' : 'bg-atren-gray'} rounded-sm relative shadow-lg`}>
            <div className={`absolute top-1 left-1 w-1 h-1 ${variant === 'white' ? 'bg-atren-gray' : 'bg-white'} rounded-xs`}></div>
          </div>
        </div>
      </div>
      
      {/* Company Name */}
      <div className="flex flex-col leading-none">
        <div className="flex items-baseline space-x-1">
          <span className={`text-3xl font-bold tracking-wider ${getOrangeColor()}`}>
            ATREN
          </span>
        </div>
        <span className={`text-xl font-semibold tracking-wide ${getTextColor()}`}>
          INVEST
        </span>
      </div>
    </Link>
  );
};

export default Logo;